export const ATTEMPTS_HUB_NAME = "attempts";
export const GLOBAL_HUB_NAME = "global";
